import type { Observable } from 'rxjs';
import type { UsuarioAttributeValidationRule } from '../models/usuario-attribute-validation.model';

export abstract class AttributeValidationMeshPort {
  abstract loadByCountry(codPais: string): Observable<UsuarioAttributeValidationRule[]>;
}
